import React from "react";
import SimpleBox from "../layout/container/SimpleBox";
import { Alert, Box, Container, Typography, useTheme } from "@mui/material";
import LargeButton from "../input/button/LargeButton";
import ShadowBox from "../layout/container/ShadowBox";
import { useNavigate } from "react-router";
import RegularLink from "../typography/RegularLink";

const NewMembership = ({ mt = 4, mb = 0, formLink = false, shaddowBox = true, maxContentSize = null }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const WrapperShaddow = shaddowBox ? ShadowBox : SimpleBox;

    const boxContent = (
        <SimpleBox fullWidth={true} flexDirection="column" gap={4}>
            <Typography fontSize="1.8rem" fontWeight="bold" align="center">
                Faz parte da FAMÍLIA ADCB
            </Typography>
            <Typography align="center" fontSize="1.2rem">
                A quota anual é de apenas 12,00 €.
            </Typography>
            <Box mt={theme.spacing(4)} mb={theme.spacing(4)}>
                <LargeButton label="Quero Ser Sócio" onClick={() => navigate(`/edit-member/NEW/null`)} />
            </Box>
            {
                formLink ? (
                    <Alert severity="info" sx={{ fontSize: "1.1rem" }}>
                        Se já és sócio mas não tens acesso aos teus dados de membro,
                        regista-te e entra no nosso site para teres acesso às funcionalidades de membro.
                        Caso tenhas dificuldade contacta-nos
                        através <RegularLink to="/about#contact">deste formulário</RegularLink> indicando
                        o teu nome completo, número de contribuinte, morada completa e email.
                        Em breve entraremos em contacto contigo para proceder à regularização dos teus dados.
                    </Alert>
                ) : (
                    <Alert severity="info" sx={{ fontSize: "1.1rem" }}>
                        Se já és sócio mas não tens acesso aos teus dados de membro,
                        contacta-nos através do formulário em baixo indicando
                        o teu nome completo, número de contribuinte, morada completa e email.
                        Em breve entraremos em contacto contigo para proceder à regularização dos teus dados.
                    </Alert>
                )
            }
        </SimpleBox>
    );

    const wrapperContent = Boolean(maxContentSize) ? (
        <Container maxWidth={maxContentSize}>
            {boxContent}
        </Container>
    ) : boxContent;

    return (
        <WrapperShaddow mt={mt} mb={mb}>
            {wrapperContent}
        </WrapperShaddow>
    );
}

export default NewMembership;
